// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const handleCloseWithTransitionend = (elm: HTMLElement, onClose: () => void) => {
  elm.ontransitionend = () => {
    onClose()
  }
}
